import { render, staticRenderFns } from "./emoji.vue?vue&type=template&id=91efc26c&scoped=true"
import script from "./emoji.vue?vue&type=script&lang=js"
export * from "./emoji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91efc26c",
  null
  
)

export default component.exports